interface TimeZonePreferenceToken {
  profileId: string
  session: number
  generation: number
}

let profileId: Maybe<string> = null
let session = 0
let generation = 0

export const setTimeZonePreferenceSession = (nextProfileId: Maybe<string>): boolean => {
  if (profileId === nextProfileId) {
    return false
  }

  profileId = nextProfileId
  session += 1
  generation = 0

  return true
}

export const getTimeZonePreferenceToken = (viewerId: string): TimeZonePreferenceToken => {
  setTimeZonePreferenceSession(viewerId)

  return { profileId: viewerId, session, generation }
}

export const beginManualTimeZoneSave = (viewerId: string): TimeZonePreferenceToken => {
  setTimeZonePreferenceSession(viewerId)
  generation += 1

  return { profileId: viewerId, session, generation }
}

export const isCurrentTimeZonePreference = (token: TimeZonePreferenceToken): boolean =>
  token.profileId === profileId && token.session === session && token.generation === generation
